/**
 * Jagad Jawa — Bausastra / Kamus Basa Jawi (jv)
 * Standar: 100% Basa Jawi ragam Krama/Madya berbobot budaya tradisional.
 */
export const jv = {
  "brand_subtitle": "Portal Budaya Nuswantara",
  "lang_toggle_badge": "JV",
  "lang_toggle_title": "Gantos Basa (Indonesia / Jawi)",
  "nav_beranda": "Pambuka",
  "nav_wektu": "Wektu & Penanggalan",
  "nav_kalender": "Kalendher Jawi",
  "nav_kalender_sub": "Pasaran, Dina Awon/Becik & Weton",
  "nav_konversi": "Konversi Tanggal Jawa",
  "nav_konversi_sub": "Masehi dhateng Jawi & Pranata Mangsa",
  "nav_nujum": "Nujum & Primbon",
  "nav_nujum_pribadi": "Nujum Pribadhi",
  "nav_nujum_sub": "Watek Bincil, Faalakiah, & Shio",
  "nav_jodoh": "Pitung Salaki Rabi",
  "nav_jodoh_sub": "Petung Jodho Salaki Rabi & Neptu",
  "nav_selametan": "Pengetan Tilar Donyo",
  "nav_selametan_sub": "Selametan Geblak dumugi Nyewu",
  "nav_ijab": "Petung Ijab (Palakrama)",
  "nav_ijab_sub": "Neptu Mirunggan, Wuku, & Surasa",
  "nav_kalender_manten": "Kalendher Dinten Sae Nikah",
  "nav_kalender_manten_sub": "Petung Ijab Manten",
  "tab_kalender_manten_title": "Kalendher Dinten Sae Palakrama",
  "tab_kalender_manten_desc": "Tabel interaktif panyaring dinten sae ijab miturut Petung Ijab Manten, Dina Gede, Dina Ijo, Dina Abang, lan analisis sasi jelek.",
  "nav_omah": "Petung Omah & Cempuri",
  "nav_omah_sub": "Pambangunan, Boyongan, & Lawangan",
  "nav_ternak": "Petung Panguripan",
  "nav_ternak_sub": "Ingon-ingon, Gerah, & Geblak",
  "nav_ternak_pemula": "Petung Wiwit Ingon-ingon",
  "nav_ternak_ahli": "Petung Panguripan (Ingon-ingon, Gerah, Geblak)",
  "nav_sasmitha": "Sasmitha (Pratandha Alam)",
  "nav_sasmitha_sub": "Impen, Kedut, Grahana, Lindhu",
  "nav_sasmitha_pemula": "Sasmitha (Impen & Kedut)",
  "nav_sasmitha_ahli": "Sasmitha (Pratandha Alam & Badan)",
  "nav_primbon": "Primbon",
  "nav_belajar": "Sinau",
  "nav_saya": "Kula",
  "mode_ringkas": "Ringkes",
  "mode_lengkap": "Jangkep",
  "mode_banner_text": "Mode Ringkes aktif kanggé pamurwakan ingkang gampil & rikat.",
  "nav_budaya": "Seni & Kabudayan",
  "nav_wuku": "Pawukon 30 Wuku",
  "nav_wuku_sub": "Pawukon Jawa: Sinta dumugi Watugunung",
  "nav_tripurusa": "Endhog Wisesa (Tripurusa)",
  "nav_tripurusa_sub": "Mitologi Antaga, Ismaya, Manikmaya",
  "nav_ensiklo_budaya": "Kawruh Kabudayan",
  "nav_ensiklo_budaya_sub": "6 Bincil, Shio, Zodiak & Neptu",
  "nav_mitologi": "Mitologi Nuswantara",
  "nav_mitologi_sub": "Mulabuka Wuku, Pasaran & Cariyos Kuno",
  "nav_gamelan": "Gamelan Jawa",
  "nav_gamelan_sub": "Gamelan Maya Pelog & Slendro",
  "nav_aksara": "Papan Aksara Jawa",
  "nav_aksara_sub": "Papan Ketik & Transliterasi Aksara",
  "nav_wayang": "Panggung Kelir Wayang",
  "nav_wayang_sub": "Pentas Wayang Kulit Interaktif",
  "nav_pitutur": "Piwulang Luhur & Cangkriman",
  "nav_pitutur_sub": "Falsafah Luhur & Uji Kawruh",
  "nav_pustaka": "Pustaka Jawa",
  "nav_pustaka_sub": "Serat Kuno, Bausastra & Usada",
  "nav_sinengker": "Pustaka Sinengker",
  "nav_sinengker_sub": "Kompas Danyang & Aji Wingit",
  "nav_laporan": "Pusat Serat Laporan Tradhisi Luhur",
  "nav_laporan_sub": "Serat Resmi & Cithak PDF",
  "hero_badge": "Warisan Adiluhung",
  "hero_today_tag": "Dinten Punika · Dinten Menika",
  "hero_btn_share_card": "Bagekaken Kartu",
  "hero_btn_share_text": "Bagekaken Serat",
  "hero_quick_actions_title": "Tumindak Gancang · Pilihan Utama",
  "hero_quick_weton": "Priksa Weton",
  "hero_quick_weton_desc": "Kalendher & Pasaran",
  "hero_quick_jodoh": "Pétung Jodhok",
  "hero_quick_jodoh_desc": "Salaki Rabi & Neptu",
  "hero_quick_ijab": "Dina Becik Ijab",
  "hero_quick_ijab_desc": "Palakrama Pengantèn",
  "hero_quick_selametan": "Wilujengan",
  "hero_quick_selametan_desc": "Geblak dumugi Nyèwu",
  "hero_title": "NYELAMI KAWRUH ADILUHUNG",
  "hero_desc": "Njlajah Kabudayan Luhur Nuswantara ing papan kosmis éndah adiluhung — pètungan kalendher Jawi, primbon petung, papan aksara, kelir wayang, lan ungeling gamelan.",
  "hero_banner_tag": "Gapura Budaya Manunggal · Warisan Luhur Nuswantara",
  "card_stories_tag": "CARIYOS",
  "card_stories_title": "Cariyos Leluhur",
  "card_stories_desc": "Falsafah gesang, piwulang luhur para leluhur Jawi, serat piwulang, sarta panggung kelir wayang purwa.",
  "card_stories_action": "Bikak Falsafah",
  "card_archive_tag": "PUSTAKA",
  "card_archive_title": "Pustaka Budaya",
  "card_archive_desc": "Pustaka komputasi kalendher Jawi, siklus Pranata Mangsa, nujum weton pribadhi, sarta petung perjodohan.",
  "card_archive_action": "Bikak Pustaka",
  "card_community_tag": "BEBRAYAN",
  "card_community_title": "Pawiyatan Bebrayan",
  "card_community_desc": "Pasinaon gamelan maya interaktif, papan transliterasi aksara Hanacaraka, lan papan kawruh kabudayan.",
  "card_community_action": "Mlebet Pawiyatan",
  "btn_back": "← Wangsul",
  "btn_back_home": "← Wangsul dhateng Pambuka",
  "btn_close": "Tutup",
  "btn_share_weton": "Andum Weton",
  "btn_save_note": "Simpen Tandha",
  "btn_copy": "Turun",
  "btn_print": "Cithak Laporan",
  "btn_download": "Undhuh",
  "btn_download_png": "Undhuh Gambar (PNG)",
  "btn_download_pdf": "Cithak PDF",
  "btn_calculate": "Pétung",
  "btn_reset": "Wangsulaken",
  "btn_reset_today": "Dinten Punika",
  "btn_search": "Padosi",
  "btn_see_more": "Pirsani Malih",
  "btn_dismiss": "Tutup Dinten Punika",
  "cal_header_title": "Kalendher Jawi · Pranata Mangsa",
  "cal_header_subtitle": "Kaitung otomatis linambaran siklus Pasaran (5), Wuku (210), lan Taun Jawi/Hijriyah.",
  "cal_saring_label": "Saring Dina:",
  "cal_filter_all": "Sedaya Dina",
  "cal_filter_ijo": "Dino Ijo (Becik)",
  "cal_filter_gede": "Dino Gede",
  "cal_filter_bookmark": "Ditandhai (Bookmark)",
  "cal_btn_print": "Cithak Laporan",
  "cal_btn_download": "Undhuh Gambar (PNG)",
  "cal_mode_grid": "Modhe Tabel (Grid)",
  "cal_mode_list": "Modhe List Pekan",
  "cal_scroll_hint": "Geser tabel kanthi horisontal kanggé mirsani sedaya dinten & wuku",
  "cal_label_bulan": "Pilih Sasi:",
  "cal_label_tahun": "Taun Masehi:",
  "cal_click_hint": "*Klik kothak tanggal kanggé rincian jangkep, tandha cathetan, & andum weton",
  "cal_wuku_ngisor_hint": "Nomor 4, 14, 24 — kala ono ngisor, ojo marani dununge wuku!",
  "modal_dino_gede_title": "DINO GEDE",
  "modal_dino_gede_desc": "Dina wigati lan sakral ing petungan pawukon & penanggalan Jawa.",
  "modal_dino_lumrah_title": "DINA LUMRAH",
  "modal_dino_lumrah_desc": "Boten klebet pengetan Dino Gede khusus.",
  "modal_status_ala_title": "STATUS: DINA AWON / NAHAS",
  "modal_status_ala_desc": "Dina awon tumrap adeg griya, mantu, utawi lelungan tebih.",
  "modal_status_becik_title": "STATUS: DINA BECIK / RAHAYU",
  "modal_status_becik_desc": "Dina becik kanggé maneka warni hajat, lelungan, lan pakaryan.",
  "sapa_dina_title": "Sapa Dina — Ringkesan Padintenan",
  "sapa_dina_weton_title": "Weton Pasaran Dinten Punika",
  "sapa_dina_neptu_title": "Pétungan Neptu",
  "sapa_dina_status_ijo": "Dina Becik (Rahayu)",
  "sapa_dina_status_ala": "Dina Awon (Sirikan)",
  "sapa_dina_status_gede": "Dina Ageng Tradhisi",
  "sapa_dina_pitutur_title": "Falsafah & Piwulang Luhur Padintenan",
  "sapa_dina_tetanen_title": "Pituduh Tetanèn & Palawija",
  "sapa_dina_pranata_title": "Kosmologi Pranata Mangsa",
  "tab_kalender_title": "Kalendher Jawi · Pranata Mangsa",
  "tab_kalender_desc": "Kaitung otomatis linambaran siklus Pasaran (5), Wuku (210), lan Taun Jawi/Hijriyah.",
  "tab_nujum_title": "Nujum Pribadhi & Kawruh Primbon",
  "tab_nujum_desc": "Watek 6 dhimènsi Bincil, zodiak pranata, shio élèmèn, watek dinten, lan jangka falakiah.",
  "tab_jodoh_title": "Pétung Jodho Salaki Rabi",
  "tab_jodoh_desc": "Pangiklasaning jodho salaki rabi linambaran neptu, babon wuku, aksara lintang, lan sisa modulo 4/5/7/8.",
  "tab_selametan_title": "Pengetan Tilar Donyo (Slametan)",
  "tab_selametan_desc": "Pétungan dinten geblak, 3 dinten, 7 dinten, 40 dinten, 100 dinten, pendhak 1, pendhak 2, dumugi nyewu (1000 dinten).",
  "tab_ijab_title": "Pétung Ijab (Palakrama)",
  "tab_ijab_desc": "Sistem Neptu Mirunggan Ijab, babon wuku palakrama, surasa weton, lan jumbuhaning sasi/taun.",
  "tab_omah_title": "Pétung Griya & Cempuri",
  "tab_omah_desc": "Paugeran ngedegaken griya, boyongan, sangang posisi lawangan cempuri, sarta sirikan arah.",
  "tab_kehidupan_title": "Pétung Panguripan (Ingon-ingon, Gerah, Geblak)",
  "tab_kehidupan_desc": "Pituduh wiwit ngingu raja-kaya, jaluran lelara tradhisional, lan tatacara pakurmatan geblak.",
  "tab_sasmitha_title": "Sasmitha (Pratandha Alam & Badan)",
  "tab_sasmitha_desc": "Tapsir impen tradhisional, tegesing kedutan perangan badan, grahana, lindhu sasi, sarta teja langit.",
  "tab_wuku_title": "Pawukon 30 Wuku Nuswantara",
  "tab_wuku_desc": "Njlajahi siklus 30 wuku wiwit Sinta dumugi Watugunung sesarengan Bathara Pangayom lan 4 pilar petenget.",
  "tab_aksara_title": "Papan Aksara Jawi",
  "tab_aksara_desc": "Papan ketik digital lan transliterasi cepet Latin dhateng Hanacaraka mawi paugeran sandhangan & pasangan.",
  "tab_wayang_title": "Panggung Kelir Wayang Kulit",
  "tab_wayang_desc": "Pentas wayang kulit interaktif mawi soroting blencong, kepyak, lan para paraga wayang.",
  "tab_konversi_title": "Komersi Tanggal Jawi (Sultan Agungan & Masehi)",
  "tab_konversi_desc": "Transformasi matematis premati antawisipun kalendher Masehi (Gregorian) kaliyan Kalendher Jawi Sultan Agungan wiwit 1555 Saka.",
  "tab_tripurusa_title": "Endhog Wisesa (Tripurusa)",
  "tab_tripurusa_desc": "Mitologi dumadining jagad raya lan mulabukaning Bathara Manikmaya, Ismaya, sarta Antaga.",
  "tab_ensiklo_budaya_title": "Kawruh Kabudayan & Kosmologi Jawi",
  "tab_ensiklo_budaya_desc": "Pawitan jero 6 dhimènsi Bincil, zodiak pranata, shio wuxing, lan siklus padewan.",
  "tab_mitologi_title": "Mitologi Nuswantara & Dongeng Kuna",
  "tab_mitologi_desc": "Mulabuka pawukon Watugunung, cariyos Dewi Sri, lan dongeng mistis tanah Jawi.",
  "tab_gamelan_title": "Gamelan Maya Interaktif",
  "tab_gamelan_desc": "Ungeling karawitan gamelan Jawi maya pelog & slendro mawi audio autentik.",
  "tab_pitutur_title": "Piwulang Luhur & Cangkriman Kawruh Budaya",
  "tab_pitutur_desc": "Mutiara falsafah leluhur Jawi lan cangkriman kanggé ngudi kawruh kabudayan.",
  "tab_tumpeng_title": "Tumpeng Tombak Rojo & Ubarampe Sesaji",
  "tab_tumpeng_desc": "Makna filosofis ubarampe sesaji, tumpeng tradhisi Jawi, lan donga karaharjan Jawi.",
  "tab_pustaka_title": "Pustaka Digital Jawi & Serat Kuno",
  "tab_pustaka_desc": "Koleksi digital naskah kuna, usada empon-empon jamu tradhisional, donga, lan serat piwulang luhur.",
  "tab_sinengker_title": "Pustaka Sinengker & Kawruh Wingit",
  "tab_sinengker_desc": "Kawruh wingit tradhisi leluhur Jawi, kompas danyang 360°, aji rajah kalacakra, lan ruwatan.",
  "tab_laporan_title": "Pusat Serat Laporan Tradhisi Luhur & Cithak Serat",
  "tab_laporan_desc": "Cithak piagam weton bingkai prada, ringkesan nujum pribadhi, lan serat pawiwahan.",
  "mode_ringkas_aktif": "Mode Ringkes Aktif:",
  "mode_ringkas_kal_desc": "Tampilan kalendher fokus ing dinten lan pasaran padintenan. Opsi cithak lan paugeran kode dipunsinggahaken.",
  "mode_ringkas_nujum_desc": "Formulir dipunsederhanakaken kanggé nujum pribadhi dhasar. Komparasi relasi lan opsi cithak kasimpen.",
  "mode_switch_lengkap": "Ngalih dhateng Mode Jangkep",
  "cal_btn_reset_today": "Dinten Punika",
  "cal_btn_export_pdf": "Cithak PDF",
  "cal_legend_hijau_label": "Blok Ijo Solid",
  "cal_legend_hijau_desc": "Dina Becik / Rahayu (74 Dina)",
  "cal_legend_merah_label": "Blok Abang Solid",
  "cal_legend_merah_desc": "Dina Awon / Nahas (136 Dina)",
  "nujum_label_tgl_lahir": "Tanggal Miyos (Masehi)",
  "nujum_label_nama": "Asma Jangkep (Kanggé Faalakiah)",
  "nujum_label_tahun": "Taun Petungan",
  "nujum_label_alamat_tinggal": "Alamat Manggon (Nama Kalurahan)",
  "nujum_label_alamat_kerja": "Alamat Panggonan Nyambut Damel (Nama Kalurahan)",
  "nujum_placeholder_nama": "Tuladha: Raden Mas Dananjaya",
  "nujum_placeholder_tinggal": "Tuladha: Delanggu",
  "nujum_placeholder_kerja": "Tuladha: Gatak",
  "nujum_btn_hitung": "Pétung Nujum Jangkep",
  "nujum_badge_tgl_jawa": "Tanggal Jawi",
  "nujum_badge_hari_pasaran": "Dina & Pasaran",
  "nujum_badge_neptu_wuku": "Neptu & Wuku",
  "nujum_badge_siklus": "Siklus Taunan",
  "nujum_badge_karakter": "Watek Dhasar",
  "nujum_badge_sirikan": "Sirikan Adhep Omah",
  "nujum_empty_state": "Klik tombol \"Pétung Nujum Jangkep\" kangge nampilaken analisis jangkep pribadhi, bincil, faalakiah nabi, asesoris ageman, lan watek wuku.",
  "nujum_btn_glosarium": "Glosarium & Pituduh Falsafah",
  "nujum_subtab_pribadi": "Nujum Pribadhi Piyambak",
  "nujum_subtab_nonjodoh": "Komparasi Sesambetan (Non-Jodho)",
  "nujum_nonjodoh_title": "Komparasi Sinergi Sesambetan & Kerja Sama (Non-Jodho)",
  "nujum_nonjodoh_desc": "Analisis jumbuhaning watek, titik temu komunikasi, potensi gesekan, lan etika kerjasama (tepa slira) kangge rencang nyambut damel, mitra usaha, kanca, menapa dene kulawarga tanpa petung palakrama.",
  "nujum_nonjodoh_p1": "Pihak Kapisan (Tiyang 1)",
  "nujum_nonjodoh_p2": "Pihak Kaping Kalih (Tiyang 2)",
  "nujum_nonjodoh_label_nama": "Asma Jangkep / Jeneng Tetepangan:",
  "nujum_nonjodoh_label_tgl": "Tanggal Miyos (Masehi):",
  "nujum_nonjodoh_label_konteks": "Konteks Sesambetan:",
  "nujum_nonjodoh_btn_bandingkan": "Bandingaken Watek & Sinergi",
  "jodoh_label_status": "Status Sesambetan Pasangan:",
  "jodoh_status_belum": "Rancangan Palakrama (Calon Pengantèn)",
  "jodoh_status_planning": "Rancangan Palakrama (Calon Pengantèn)",
  "jodoh_status_engaged": "Lamaran / Pacangan",
  "jodoh_status_sudah": "Sampun Palakrama (Pasangan)",
  "jodoh_status_married": "Sampun Palakrama (Pasangan)",
  "jodoh_wanita_title": "Data Calon Pengantèn Putri (♀)",
  "jodoh_pria_title": "Data Calon Pengantèn Kakung (♂)",
  "jodoh_label_nama": "Asma Jangkep (Pilihan)",
  "jodoh_label_aksara_depan": "Aksara Ngajeng",
  "jodoh_label_aksara_belakang": "Aksara Wingking",
  "jodoh_label_tgl_lahir": "Tanggal Miyos (Wajib)",
  "jodoh_label_hari": "Dinten",
  "jodoh_label_pasaran": "Pasaran",
  "jodoh_label_neptu": "Neptu Dina + Pasaran:",
  "jodoh_btn_hitung": "Pétung Nujum Jejodohan",
  "jodoh_empty_title": "Pétung Salaki Rabi (Pitung Jejodohan)",
  "jodoh_empty_desc": "Mangga dipunpilih status sesambetan, nemtokaken tanggal miyos calon pengantèn putri lan kakung, lajeng klik \"Pétung Nujum Jejodohan\" kangge mriksani asil jumbuhaning lan pandom.",
  "jodoh_hasil_title": "Asil Nujum Jejodohan Miturut Pitung Jawi",
  "jodoh_tabel_no": "No",
  "jodoh_tabel_hasil": "Asil Pétung",
  "jodoh_tabel_arti": "Teges / Wedharan",
  "jodoh_tabel_status": "Status",
  "jodoh_wizard_step1": "Langkah 1 saking 4: Status Sesambetan Pasangan",
  "jodoh_wizard_step2": "Langkah 2 saking 4: Data Calon Pengantèn Kakung",
  "jodoh_wizard_step3": "Langkah 3 saking 4: Data Calon Pengantèn Putri",
  "jodoh_wizard_step4": "Langkah 4 saking 4: Ringkesan Asil & 7 Metode Pitung",
  "jodoh_wizard_btn1": "1. Status",
  "jodoh_wizard_btn2": "2. Kakung",
  "jodoh_wizard_btn3": "3. Putri",
  "jodoh_wizard_btn4": "4. Asil & 7 Metode",
  "jodoh_lanjut_wanita": "Lanjut dhateng Data Putri (Langkah 3)",
  "jodoh_lanjut_pria": "Lanjut dhateng Data Kakung (Langkah 2)",
  "jodoh_lanjut_hasil": "Petung & Mirsani Asil (Langkah 4)",
  "jodoh_kembali_status": "Kondur dhateng Status Sesambetan (Langkah 1)",
  "jodoh_kembali_wanita": "Kondur dhateng Data Putri (Langkah 3)",
  "jodoh_kembali_pria": "Kondur dhateng Data Kakung (Langkah 2)",
  "jodoh_detail_accordion_title": "Mriksani Analisis Jangkep 7 Metode Pitung",
  "jodoh_cta_buka_ijab": "Bikak Rekomendasi Dinten Sae ing Pétung Ijab",
  "jodoh_riwayat_title": "Riwayat Pétungan Pasangan",
  "jodoh_riwayat_desc": "Kasimpen sacara lokal ing peramban panjenengan (privasi terjamin)",
  "jodoh_riwayat_hapus": "Resiki Sedaya",
  "selametan_wizard_step1": "Langkah 1 saking 3: Tanggal Tilar Donyo / Geblak",
  "selametan_wizard_step2": "Langkah 2 saking 3: Wektu Tilar Donyo (Sadèrèng / Bakda Maghrib)",
  "selametan_wizard_step3": "Langkah 3 saking 3: Jadwal 7 Milestone Pengetan",
  "selametan_wizard_btn1": "1. Tanggal Wafat",
  "selametan_wizard_btn2": "2. Wektu Surup",
  "selametan_wizard_btn3": "3. Jadwal Pengetan",
  "selametan_lanjut_waktu": "Lanjut dhateng Wektu Tilar Donyo (Langkah 2)",
  "selametan_lanjut_jadwal": "Mriksani Jadwal 7 Milestone (Langkah 3)",
  "selametan_kembali_tanggal": "Kondur dhateng Tanggal Tilar Donyo (Langkah 1)",
  "selametan_kembali_waktu": "Kondur dhateng Wektu Tilar Donyo (Langkah 2)",
  "selametan_waktu_unselected_error": "Pilih wektu tilar donyo (sadèrèngipun Maghrib utawi bakda Maghrib) rumiyin.",
  "selametan_opt_siang_title": "Awan / Sadèrèngipun Maghrib (Sadèrèngipun Surup)",
  "selametan_opt_siang_desc": "Tilar donyo sadèrèngipun tabuh 18.00 sonten. Tanggal Masehi lan dina Jawa tetep sami minangka dina Geblak.",
  "selametan_opt_malam_title": "Dalu / Bakda Maghrib (Bakda Surup)",
  "selametan_opt_malam_desc": "Tilar donyo sasampunipun tabuh 18.00 sonten. Dina Jawa gantos dhumateng dinten candhakipun miturut paugeran Sultan Agungan.",
  "selametan_detail_accordion_title": "Mriksani Rincian Jangkep Sedaya 7 Milestone & Tabel",
  "selametan_label_nama": "Asma Swargi / Swarginah (Opsional)",
  "selametan_placeholder_nama": "Tuladha: Ki Ageng Suryo / Ibu Warsiti",
  "selametan_label_tgl_wafat": "Tanggal Tilar Donyo / Geblak (Masehi — Wajib)",
  "selametan_label_waktu": "Wektu Tilar Donyo (Surup / Maghrib — Wajib Dipilih)",
  "selametan_opt_siang": "Awan / Sadèrèngipun Maghrib (Tanggal Masehi = Dina Geblak)",
  "selametan_opt_malam": "Dalu / Bakda Maghrib (Surup — Dina Jawa gantos dhateng candhakipun)",
  "selametan_label_keyakinan": "Refleksi Donga & Keyakinan (Inklusif 6 Agami)",
  "selametan_lintas_agama": "Lintas Agami & Kabudayan",
  "selametan_warning_title": "Wigati — Gantos Dina Jawi:",
  "selametan_warning_desc": "Miturut tradhisi Jawi, dinten gantos sasampunipun tabuh 18.00 (sonten/surup). Manawi tilar donyo sasampunipun tabuh 18.00, dinten ingkang dipunginakaken inggih dinten candhakipun.",
  "selametan_btn_hitung": "Pétung Wilujengan",
  "selametan_hasil_title": "Rincian Dina Pengetan Wilujengan",
  "selametan_tabel_pengetan": "Pengetan",
  "selametan_tabel_dina": "Dina + Pasaran",
  "selametan_tabel_tgl": "Tanggal Masehi",
  "selametan_tabel_ket": "Katrangan",
  "selametan_note": "*Wilujengan limrahipun dipunadani sonten/dalu (sasampunipun Maghrib / tabuh 18.00) miturut adat tata cara setempat.",
  "ijab_badge": "Paugeran Palakrama",
  "ijab_label_tgl": "Tanggal Akad (Masehi)",
  "ijab_label_dina": "Dina",
  "ijab_label_pasaran": "Pasaran",
  "ijab_label_wuku": "Wuku Palakrama",
  "ijab_label_sasi": "Sasi Jawi",
  "ijab_label_tahun": "Taun Jawi (Windu)",
  "ijab_label_tgl_jawa": "Tanggal Jawi (1-30)",
  "ijab_label_panjampet": "Paramèter Panjampet Pilihan (Opsional):",
  "ijab_autofill_hint": "Otomatis ngisi Dina, Pasaran, Wuku, & Sasi Jawi.",
  "ijab_btn_hitung": "Pétung Ijab (Babar Kawigatosan)",
  "ijab_btn_today": "Dinten Punika",
  "intent_title": "Kula Badhé...",
  "intent_subtitle": "Gapura Pintar Fitur Luhur",
  "intent_weton": "Priksa Weton",
  "intent_weton_sub": "Dina & Pasaran",
  "intent_jodoh": "Pétung Jodho",
  "intent_jodoh_sub": "7 Cara Pitung",
  "intent_ijab": "Dina Akad Ijab",
  "intent_ijab_sub": "Palakrama Rahayu",
  "intent_selametan": "Wilujengan Wafat",
  "intent_selametan_sub": "Geblak s/d Nyèwu",
  "intent_omah": "Pétung Omah",
  "intent_omah_sub": "Cempuri & Pindhah",
  "intent_ternak": "Ingon & Tetanèn",
  "intent_ternak_sub": "Wiwit Ingon-ingon",
  "ijab_wizard_step1": "Langkah 1 saking 4: Sumber Data & Tanggal Akad",
  "ijab_wizard_step2": "Langkah 2 saking 4: Kaselarasan Weton & Wuku",
  "ijab_wizard_step3": "Langkah 3 saking 4: Paramèter Panjampet Pilihan",
  "ijab_wizard_step4": "Langkah 4 saking 4: Rekomendasi & Asil Pambiji",
  "ijab_wizard_btn1": "1. Sumber Data",
  "ijab_wizard_btn2": "2. Weton & Wuku",
  "ijab_wizard_btn3": "3. Panjampet",
  "ijab_wizard_btn4": "4. Rekomendasi",
  "ijab_lanjut_weton": "Lajeng dhateng Weton & Wuku (Langkah 2)",
  "ijab_lanjut_panjampet": "Lajeng dhateng Panjampet (Langkah 3)",
  "ijab_lanjut_rekomendasi": "Mirsani Rekomendasi & Asil (Langkah 4)",
  "ijab_kembali_tanggal": "Wangsul dhateng Sumber Data (Langkah 1)",
  "ijab_kembali_weton": "Wangsul dhateng Weton & Wuku (Langkah 2)",
  "ijab_kembali_panjampet": "Wangsul dhateng Panjampet (Langkah 3)",
  "saya_badge": "Profil & Kawruh Pribadhi",
  "saya_title": "Pribadhi & Setelan Aplikasi",
  "saya_desc": "Kelola weton miyos pribadhi, simpenan pétungan, sarta preferensi tampilan Jagad Jawa.",
  "saya_weton_title": "Weton Pribadhi Kula",
  "saya_weton_stored": "Kasimpen ing Piranti",
  "saya_label_tgl_lahir": "Tanggal Miyos Panjenengan",
  "saya_weton_label": "Weton Miyos",
  "saya_wuku_label": "Wuku Miyos",
  "saya_pick_date": "Pilih tanggal miyos",
  "saya_pref_title": "Preferensi Tampilan & Basa",
  "saya_mode_title": "Mode Antarmuka",
  "saya_mode_desc": "Pilih antawisipun Mode Ringkes (kawitan) utawi Mode Jangkep (ahli).",
  "saya_mode_btn": "Gantos Mode",
  "saya_bahasa_title": "Bahasa / Basa",
  "saya_bahasa_desc": "Beralih antawisipun Basa Indonesia lan Basa Jawi.",
  "saya_bahasa_btn": "Gantos Basa (ID/JV)",
  "saya_tema_title": "Tema Visual",
  "saya_tema_desc": "Pilihan nuansa peteng utawi padhang.",
  "saya_tema_btn": "Gantos Tema",
  "saya_dokumen_title": "Pusat Serat & Laporan PDF",
  "saya_dokumen_desc": "Akses berkas cithak laporan penanggalan, primbon jodho, lan arsip tradhisi luhur.",
  "saya_dokumen_btn": "Bikak Pusat Serat",
  "bottomnav_beranda": "Pambuka",
  "bottomnav_kalender": "Kalendher",
  "bottomnav_primbon": "Primbon",
  "bottomnav_belajar": "Sinau",
  "bottomnav_saya": "Kula",
  "btn_next": "Lajeng",
  "btn_prev": "Kondur",
  "btn_hapus_semua": "Resiki Sedaya",
  "btn_export_pdf": "Cithak PDF",
  "lbl_opsional": "Opsional",
  "toast_share_success": "Kasil dipunbagiaken! ✨",
  "toast_copy_success": "Teks kasil disalin dhateng clipboard!",
  "toast_save_success": "Data kasil kasimpen.",
  "toast_kalender_reset": "Kalendher kondur dhateng sasi & dinten punika ✨",
  "menu_card_kalender_title": "Kalendher Jawi",
  "menu_card_kalender_desc": "Masehi, Pasaran, Wuku, Dino Gede, lan status Awon/Becik.",
  "menu_card_nujum_title": "Nujum Pribadhi",
  "menu_card_nujum_desc": "Bincil, Faalakiah 12 Nabi saking asma, Asesoris, & Watek.",
  "menu_card_jodoh_title": "Pétung Jodho",
  "menu_card_jodoh_desc": "Jumbuhaning 7 metode primbon aksara & neptu jodho.",
  "menu_card_selametan_title": "Pengetan Tilar Donyo",
  "menu_card_selametan_desc": "Pengetan 3, 7, 40, 100, Pendhak 1-2, lan Nyèwu 1000 dinten.",
  "menu_card_ijab_title": "Pétung Ijab (Palakrama)",
  "menu_card_ijab_desc": "Sistem Neptu Mirunggan Ijab, babon wuku, surasa weton, lan sasi.",
  "menu_card_omah_title": "Pétung Griya & Cempuri",
  "menu_card_omah_desc": "Bumi, Kerta, Guru (sisa modulo), 9 cempuri lawangan, & sirikan arah.",
  "menu_card_ternak_ringkas_title": "Pétung Wiwit Ingon-ingon",
  "menu_card_ternak_lengkap_title": "Pétung Panguripan",
  "menu_card_ternak_ringkas_desc": "Paugeran wiwit ngingu raja-kaya (Gajah, Suku, Watu, Buto).",
  "menu_card_ternak_lengkap_desc": "Wiwit ternak, jaluran gerah & tombo, sarta wiradat 40 dinten geblak.",
  "menu_card_sasmitha_ringkas_title": "Sasmitha Impen & Kedut",
  "menu_card_sasmitha_lengkap_title": "Sasmitha (Pratandha Alam & Badan)",
  "menu_card_sasmitha_ringkas_desc": "Tapsir 99 impen & pratandha 74 kedutan perangan badan.",
  "menu_card_sasmitha_lengkap_desc": "Kawruh impen, kedut, grahana, lindhu sasi, & teja 7 puser arah.",
  "menu_card_aksara_title": "Papan Aksara Jawi",
  "menu_card_aksara_desc": "Transliterasi otomatis Latin dhateng Hanacaraka & kanvas nulis.",
  "menu_card_wayang_title": "Panggung Kelir Wayang",
  "menu_card_wayang_desc": "Pentas wayang kulit mawi blencong & kepyak.",
  "menu_card_gamelan_title": "Gamelan Jawa",
  "menu_card_gamelan_desc": "Ungeling Saron, Bonang, Kempul & Gong (Slendro & Pelog).",
  "menu_card_pitutur_title": "Piwulang & Cangkriman Kawruh",
  "menu_card_pitutur_desc": "Falsafah gesang lan cangkriman kawruh budaya mawi gelar.",
  "menu_card_tumpeng_title": "Tumpeng Tombak Rojo",
  "menu_card_tumpeng_desc": "Filosofi 5 werna, ubarampe sesaji tolak bala, lan donga karaharjan.",
  "hero_pitutur_header": "Piwulang Luhur Dinten Punika",
  "hero_pitutur_source": "Falsafah Luhur Jawi",
  "hero_pranata_header": "Pranata Mangsa",
  "hero_kala_header": "Dununge Kala (Panggonan)",
  "hero_kala_sub": "Arah sirikan lumampahing wuku",
  "hero_tetanen_header": "Pétung Tetanèn & Palawija",
  "hero_status_gede": "Dino Gede (Sakral)",
  "hero_status_becik": "Dina Becik (Rahayu)",
  "hero_status_ala": "Dina Awon (Prayitna)",
  "hero_accordion_open": "Bikak Rincian Dinten Punika & Piwulang",
  "hero_accordion_close": "Tutup Rincian Dinten Punika",
  "hero_tetanen_becik": "Kang becik:",
  "omah_badge": "Kawruh Arsitektur Tradhisional",
  "omah_label_tgl": "Tanggal Ngedekake / Boyongan",
  "omah_tgl_hint": "Otomatis sinkron Dina, Pasaran, & Sasi Jawi.",
  "omah_label_dina": "Dina",
  "omah_label_pasaran": "Pasaran",
  "omah_label_arah_lawang": "Madhep Lawang (Arah)",
  "omah_label_params": "Paramèter Cempuri, Boyongan & Siti:",
  "omah_label_nomor_lawang": "Posisi Lawang (1-9)",
  "omah_label_arah_pindah": "Arah Pindah / Boyongan",
  "omah_label_sasi": "Sasi Jawi",
  "omah_label_mangsa": "Pranata Mangsa",
  "omah_label_lemah": "Ciri Lemah / Siti",
  "omah_btn_hitung": "Pétung Griya (Babar Padunungan)",
  "omah_search_title": "Pados Dinten Sae (Interaktif)",
  "omah_search_desc": "Pados tanggal, wulan, lan warsa ingkang trep kanggé ngedekake utawi boyongan adhedhasar formula Set A, B, lan C.",
  "omah_search_bulan": "Wulan Masehi",
  "omah_search_tahun": "Taun Masehi",
  "omah_label_tujuan": "Ancas Hajat Griya",
  "omah_wizard_step1": "Langkah 1 saking 4: Ancas, Tanggal & Arah Lawang Utama",
  "omah_wizard_step2": "Langkah 2 saking 4: Posisi Lawang Cempuri (1-9)",
  "omah_wizard_step3": "Langkah 3 saking 4: Karakteristik Siti & Mangsa",
  "omah_wizard_step4": "Langkah 4 saking 4: Asil Pametung & Rekomendasi",
  "omah_wizard_btn1": "1. Ancas & Tanggal",
  "omah_wizard_btn2": "2. Cempuri",
  "omah_wizard_btn3": "3. Siti & Mangsa",
  "omah_wizard_btn4": "4. Asil Petung",
  "omah_lanjut_cempuri": "Lajeng dhateng Posisi Cempuri (Langkah 2)",
  "omah_lanjut_lahan": "Lajeng dhateng Siti & Mangsa (Langkah 3)",
  "omah_lanjut_hasil": "Etung & Tingali Asil (Langkah 4)",
  "omah_kembali_tanggal": "Wangsul dhateng Tanggal & Arah (Langkah 1)",
  "omah_kembali_cempuri": "Wangsul dhateng Posisi Cempuri (Langkah 2)",
  "omah_kembali_lahan": "Wangsul dhateng Siti & Mangsa (Langkah 3)",
  "omah_mode_lengkap": "Mode Formulir Jangkep",
  "omah_mode_ringkas": "Mode Stepper Ringkes",
  "ternak_badge_ringkas": "Paugeran Wiwit Ngingu",
  "ternak_badge_lengkap": "Pétung Panguripan Padintenan",
  "ternak_label_tujuan": "Pilih Ancas / Tindakan",
  "ternak_act_ternak_title": "Wiwit Ngingu Raja-Kaya",
  "ternak_act_ternak_desc": "Paugeran 4 Kategori (Gajah, Suku, Watu, Buto)",
  "ternak_act_tetanen_title": "Petung Tetanèn & Palawija",
  "ternak_act_tetanen_desc": "Kesesuaian 4 Golongan Tanduran (Oyot, Uwit, Kembang, Uwoh)",
  "ternak_act_loro_title": "Jalaran Loro & Tombo",
  "ternak_act_loro_desc": "Husada tradisi & pènget medis wigati",
  "ternak_act_geblak_title": "Petung Duka & Geblak",
  "ternak_act_geblak_desc": "Wiradat 40 dinten & pakurmatan suwargi",
  "ternak_btn_hitung": "Etung Petung Kehidupan",
  "ternak_err_tanggal_wajib": "Tanggal kedadosan utawi wiwitan kedah dipunisi rumiyin.",
  "ternak_err_weton_wajib": "Dina lan Pasaran kedah dipunpilih rumiyin.",
  "ternak_label_tgl": "Tanggal Kedadosan / Wiwitan",
  "ternak_tgl_hint": "Otomatis ndeteksi Dina, Pasaran, lan Neptu.",
  "ternak_search_title": "Pados Kecocokan Dinten (Interaktif)",
  "ternak_search_desc": "Pados tanggal, wulan, lan warsa ingkang trep kanggé Wiwit Ternak, Jalaran Loro, utawi Geblak adhedhasar formula weton 35.",
  "ternak_search_bidang": "Bidhang Pétung",
  "ternak_search_kategori": "Kategori / Paugeran",
  "ternak_search_btn": "Pados Dinten",
  "ternak_opt_ternak": "Wiwit Ingon-ingon",
  "ternak_opt_tetanen": "Nandur Tetanèn",
  "ternak_opt_loro": "Jalaran Loro",
  "ternak_opt_geblak": "Pétung Geblak",
  "ternak_opt_kat_becik": "Dina Becik: Gajah & Suku",
  "ternak_opt_kat_gajah": "Kategori Gajah (Agung / Luhur)",
  "ternak_opt_kat_suku": "Kategori Suku (Sugih / Mulyo)",
  "ternak_opt_kat_watu": "Kategori Watu (Netral / Prihatin)",
  "ternak_opt_kat_buto": "Kategori Buto (Waspada)",
  "ternak_opt_kat_all": "Sedaya Kategori",
  "sasmitha_badge_ringkas": "Pitedah Kawruh Adat",
  "sasmitha_badge_lengkap": "Sasmitha Pratandha Alam & Raga",
  "aksara_sejarah_badge": "Mulabuka Carakan Jawi",
  "aksara_sejarah_legend": "Legenda Aji Saka, Dora & Sembada",
  "aksara_sejarah_title": "Sejarah Dumadine 20 Aksara Jawa (Hanacaraka)",
  "aksara_input_title": "Ketik Teks Latin (Transliterasi Otomatis)",
  "aksara_input_clear": "Busak Latin",
  "aksara_input_placeholder": "Ketik basa Jawa latin ing kene, tuladha: sugeng rawuh wonten jagad jawa...",
  "aksara_sample_label": "Tuladha Cepet:",
  "aksara_output_title": "Asil Transliterasi & Editor Aksara Jawa",
  "aksara_output_clear": "Resiki",
  "aksara_output_copy": "Turun Aksara",
  "aksara_output_standard": "Kaidah Kongres Basa Jawa & Sastra.org",
  "aksara_keyboard_title": "Papan Ketik Interaktif Aksara Jawa",
  "aksara_keyboard_desc": "Klik aksara, pasangan, utawa sandhangan kanggo nyusun teks kanthi manual langsung ing posisi kursor.",
  "gamelan_badge_music": "Seni Karawitan & Sastra Tembang",
  "gamelan_badge_macapat": "11 Tembang Macapat Jawi",
  "gamelan_intro_title": "Kawruh Dhasar Karawitan",
  "gamelan_macapat_title": "11 Tembang Macapat & Paugeran",
  "gamelan_macapat_desc": "Filosofi lumakuning urip manungsa wiwit wiji nganti puput (pati)",
  "pitutur_btn_today": "Piwulang Dinten Punika",
  "pitutur_btn_random": "Gantos Piwulang (Acak)",
  "pitutur_btn_copy": "Turun Piwulang",
  "pitutur_btn_share_wa": "Bagekaken WhatsApp",
  "pitutur_quiz_title": "Kuis Asah Kawruh Kabudayan Jawi",
  "pitutur_quiz_desc": "Uji sepira jero kawruh panjenengan bab seni, tradhisi, lan sastra Jawi.",
  "pitutur_quiz_soal": "Pitakon:",
  "pitutur_quiz_skor": "Biji:",
  "wuku_top_badge": "Pawukon Jawi • 210 Dinten Satunggal Siklus",
  "wuku_btn_12_batara": "12 Batara-Batari",
  "wuku_btn_mode_modal": "Mode Dialog Modal",
  "wuku_banner_badge": "Direktori Komplit Pawukon Jawi",
  "wuku_banner_title": "Siklus 30 Wuku: Sinta dumugi Watugunung",
  "wuku_banner_desc": "Saben wuku lumampah laminipun pitung dinten (7 dina). Saben wuku nggadhahi panguwasa Dewa, watak budi pakarti, larangan bilahi (sengkolo), sesaji ruwat pangupaya karahayon, sarta do'a tolak bala kangge njagi karukunan lair batin.",
  "wuku_search_placeholder": "Pados wuku, dewa, profesi, tetanduran...",
  "wuku_hint_click": "Klik salah satunggaling kartu wuku ing ngandhap kanggé mirsani rincian jangkep",
  "wuku_filter_label": "Pilar Nujum:",
  "wuku_pill_all": "Kabeh (30 Wuku)",
  "wuku_pill_nambani": "Nambani (Usada)",
  "wuku_pill_pangupajiwa": "Pangupajiwa (Rejeki)",
  "wuku_pill_tetanen": "Tetanen (Pertanian)",
  "wuku_pill_ala_becik": "Ala & Becik",
  "wuku_list_title": "Daftar 30 Wuku (Urut 1 - 30):",
  "wuku_cycle_duration": "210 Dina Siklus",
  "modal_wuku_title": "Ensiklopedia 30 Wuku Nusantara",
  "modal_wuku_desc": "Direktori komplit Pawukon Jawi: Sinta dumugi Watugunung (Dewane, Watak, Bilahi, & Ruwat)",
  "mitologi_top_badge": "Sastra & Mitologi Kuno",
  "mitologi_badge_heritage": "Carita Warisan Luhur",
  "mitologi_banner_badge": "Kosmologi & Jagad Mistik Jawa",
  "mitologi_banner_title": "Sangkan Paraning Dongeng & Sastra Budaya",
  "mitologi_banner_desc": "Nusantara kasusun saking geguritan sejarah, kapitayan purba, lan mitologi adiluhung. Ing ngriki kacathet asal-usul 30 siklus wuku saking tragedi agung Prabu Watugunung, dumadine 5 pasaran Jawa, sarta pasrawungan gaib para danyang kaliyan para linuwih tanah Jawa.",
  "mitologi_btn_read": "Waos Langkung Jangkep",
  "mitologi_modal_font": "Aksara",
  "mitologi_modal_copy": "Turun Cariyos",
  "mitologi_modal_summary_title": "Ringkesan Cariyos:",
  "mitologi_modal_tokoh_title": "Paraga / Unsur Wigati:",
  "mitologi_modal_moral_title": "Falsafah & Piwulang Luhur:"
};

export default jv;
